import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';



export default function Setting({
    isOpened,
    handleClose,
    eventName,
    dateTime,
    selectedSlot
}) {
    const getReminderHours = () => {
        var remindersHours = [];
        for (var i = 0; i < 24; i++) {
            remindersHours.push(i + 1);
        }

        return remindersHours;
    }
    return (
        <Dialog
            open={isOpened}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
            className="view-attendee-modal"
        >
            <DialogTitle id="responsive-dialog-title">
                {eventName}
            </DialogTitle>
            <DialogContent>

                <div>
                    <div>
                        <span><b>When : </b> {dateTime}</span>
                    </div>
                        <div className="form-control-select-boxs">
                            <span># of attendees</span>
                            <TextField
                            margin="normal"
                            variant="outlined"
                            id='confirmslot'
                            fullWidth
                            type="number"
                            defaultValue={selectedSlot.seats}
                            disabled={true}
                            />
                        </div>

                        <div className="form-control-select-boxs">
                            <span># of waitlisted attendees</span>
                            <TextField
                                margin="normal"
                                variant="outlined"
                                id='WaitingSlot'
                                fullWidth
                                type="number"
                            defaultValue={selectedSlot.waitingseats}
                            disabled={true}
                            />
                        </div>
                    <div className="form-control-select-boxs Minutes-select-box">
                        <span>Event duration</span>
                            <TextField
                                margin="normal"
                                variant="outlined"
                                id='duration'
                                fullWidth
                                type="number"
                            defaultValue={selectedSlot.duration}
                            disabled={true}
                        />
                        <div className="Minutes-select">
                        <FormControl variant="outlined">

                            <Select
                                labelId="DurationUnitLabel"
                                id="durationUnit"
                                value={selectedSlot.durationunit}
                                disabled={true}
                                margin="normal"
                            >
                                <MenuItem value={'hour'}>Hours</MenuItem>
                                <MenuItem value={'minute'}>Minutes</MenuItem>
                            </Select>
                            </FormControl>
                            </div>
                        </div>
                       
                    <div className="form-control-select-boxs Minutes-select-box1">
                        <span>Reminders</span>
                        <FormControl variant="outlined" margin="normal">
                            <Select
                                labelId="reminder"
                                id="reminder"
                                defaultValue={selectedSlot.reminder}
                                disabled={true}
                            >
                                <MenuItem value={'yes'}>Yes</MenuItem>
                                <MenuItem value={'no'}>No</MenuItem>
                            </Select>
                            <div className="Minutes-select">
                                <Select
                                    labelId="reminderHours"
                                    id="reminderHours"
                                    defaultValue={selectedSlot.reminderhour}
                                    disabled={true}
                                >
                                    {
                                        getReminderHours().map((el, index) => {
                                            return (
                                                <MenuItem value={el}>{el} Hours</MenuItem>
                                            )
                                        }
                                        )
                                    }

                                </Select>
                                </div>
                        </FormControl>
                    </div>
                </div>
            </DialogContent>
            {handleClose && (
                <DialogActions>
                    <Button variant="contained" className='notification-modal-close' onClick={handleClose}>
                        CANCEL
            </Button>
                </DialogActions>
            )}
        </Dialog>
    );
}